import { createContext, useContext } from "react";

export interface AutoPredictionsContextType {
    registerTrigger: (trigger: () => Promise<void>) => void;
    triggerPredictions: () => Promise<void>;
    notifyBoxDrawn: () => void;
    registerBoxDrawnCallback: (callback: () => void) => void;
    isAutoPredictionPending: boolean;
    setIsAutoPredictionPending: (pending: boolean) => void;
}

export const AutoPredictionsContext = createContext<AutoPredictionsContextType | undefined>(
    undefined
);

export const useAutoPredictionsTrigger = () => {
    const ctx = useContext(AutoPredictionsContext);
    if (!ctx)
        throw new Error("useAutoPredictionsTrigger must be used within AutoPredictionsProvider");
    return ctx;
};

export const useAutoPredictionPending = () => {
    const ctx = useContext(AutoPredictionsContext);
    if (!ctx)
        throw new Error("useAutoPredictionPending must be used within AutoPredictionsProvider");
    return ctx.isAutoPredictionPending;
};
